export const TextAreaDefaultRowsCount = 2;
export const separator = '.';
